import moment from 'moment'
import thaiLocale from 'moment/locale/th'
import React from 'react'
import { Grid, Row, Col } from 'rsuite'

export default function ProjectTypeGroupView(props) {
  const { schema, isSubProject } = props

  const renderProjectType = () => {
    switch (schema.projectType.value) {
      case schema.projectType.project.value:
        return `${schema.projectType.project.label} : ${getSubProjectResult()}`
      case schema.projectType.projectKit.value:
        return `${schema.projectType.projectKit.label} : ${getSubProjectResult()}`
      // return schema.projectType.projectKit.label
      case schema.projectType.projectPlan.value:
        return `${schema.projectType.projectPlan.label} : ${getSubProjectResult()}`
      // return schema.projectType.projectPlan.label
      default:
        return '- ไม่ระบุ -'
    }
  }

  const getSubProjectResult = () => {
    switch (schema.projectType.subProject.value) {
      case schema.projectType.subProject.newProject.value:
        return schema.projectType.subProject.newProject.label
      case schema.projectType.subProject.ongoingProject.value:
        return (
          schema.projectType.subProject.ongoingProject.label +
          ' ' +
          schema.projectType.subProject.projectCode.value
        )
      default:
        return '- ไม่ระบุ -'
    }
  }

  const getDisplayText = (options, value) => {
    let label = ''
    options.forEach((item) => {
      if (value == item.value) {
        label += item.label
      }
    })
    return label ? label : '- ไม่ระบุ -'
  }

  const toThDate = (value) => {
    moment.locale('th', thaiLocale)
    const date = moment(value, 'YYYY/MM/DD')
    if (date.isValid()) {
      let convertDate = date.add(543, 'year').format('/MMM/YYYY')
      return value.substring(value.length-2, value.length) + convertDate
    }
  }

  return (
    <Row style={{ paddingLeft: 10 }}>
      <Col xs={24} sm={24} md={24} lg={24}>
        <p>
          {schema.projectFeature.label} :{' '}
          <b>{getDisplayText(schema.projectFeature.options, schema.projectFeature.value)}</b>
        </p>

        {!isSubProject && schema?.projectType && (
          <p>
            {schema.projectType.label} : <b>{renderProjectType()}</b>
          </p>
        )}

        <p>
          {schema.offerFunded.label} :{' '}
          <b>{getDisplayText(schema.offerFunded.options, schema.offerFunded.value)}</b>
        </p>
        <p>
          {schema.workingTime.label} :{' '}
          <li style={{ marginLeft: 50 }}>
            {schema.workingTime.actualPeriod.value == 2
              ? 'คาดว่าจะเริ่ม'
              : schema.workingTime.startDate.label}{' '}
            : <b>{toThDate(schema.workingTime.startDate.value) || '- ไม่ระบุ -'}</b>
          </li>
          {schema.workingTime.actualPeriod.value == 1 && (
            <li style={{ marginLeft: 50 }}>
              {schema.workingTime.endDate.label} :{' '}
              <b>{toThDate(schema.workingTime.endDate.value) || '- ไม่ระบุ -'}</b>
            </li>
          )}
          {schema.workingTime.actualPeriod.value == 2 && (
            <li style={{ marginLeft: 50 }}>
              {schema.workingTime.monthCount.label} :{' '}
              <b>
                {schema.workingTime.monthCount.value
                  ? schema.workingTime.monthCount.value
                  : '- ไม่ระบุ -'}
              </b>
            </li>
          )}
          {schema.workingTime.monthCount && (
            <li style={{ marginLeft: 50 }}>
              {schema.workingTime.monthCount.label} :{' '}
              <b>
                {schema.workingTime.monthCount.value
                  ? schema.workingTime.monthCount.value
                  : '- ไม่ระบุ -'}
              </b>
            </li>
          )}
          {/* {schema.workingTime.projectReportDay && (
                <li style={{ marginLeft: 50 }}>
                  {schema.workingTime.projectReportDay.label} :{' '}
                  <b>
                    {schema.workingTime.projectReportDay.value
                      ? schema.workingTime.projectReportDay.value
                      : '- ไม่ระบุ -'}
                  </b>
                </li>
              )} */}
        </p>
      </Col>
    </Row>
  )
}
